import Tooltip from '@mui/material/Tooltip';
import { MyMVariantLabel } from './MyMLabel';

// 2024.9.16 MyMine Version2.0対応 Modify Start
export const MyMTooltip = ({ children, title, placement, ...props }) =>
  <Tooltip placement={placement ? placement : 'bottom'} title={<MyMVariantLabel variant='body2'>{title}</MyMVariantLabel>} {...props}>
    {/*2024.9.16 MyMine Version2.0対応 Modify End*/}
    <span>{children}</span>
  </Tooltip>